import * as i0 from "@angular/core";
import * as i1 from "./patient.account.proxy";
var PatientAccountService = /** @class */ (function () {
    function PatientAccountService(patientAccountProxy) {
        this.patientAccountProxy = patientAccountProxy;
    }
    PatientAccountService.prototype.locatePatient = function (patientData) {
        return this.patientAccountProxy.locatePatient(patientData);
    };
    PatientAccountService.prototype.createPatientAccount = function (patientDataWithAccountDetails) {
        return this.patientAccountProxy.createPatientAccount(patientDataWithAccountDetails);
    };
    PatientAccountService.prototype.generatePatientUserName = function (patientData) {
        return this.patientAccountProxy.generatePatientUserName(patientData);
    };
    PatientAccountService.prototype.getPatientUserName = function (patientData) {
        return this.patientAccountProxy.getPatientUserName(patientData);
    };
    PatientAccountService.prototype.generateOneTimeCode = function (patientData) {
        return this.patientAccountProxy.generateOneTimeCode(patientData);
    };
    PatientAccountService.prototype.validateOneTimeCode = function (oneTimeCodeData) {
        return this.patientAccountProxy.validateOneTimeCode(oneTimeCodeData);
    };
    PatientAccountService.prototype.changePassword = function (userCredentials) {
        return this.patientAccountProxy.changePassword(userCredentials);
    };
    PatientAccountService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PatientAccountService_Factory() { return new PatientAccountService(i0.ɵɵinject(i1.PatientAccountProxy)); }, token: PatientAccountService, providedIn: "root" });
    return PatientAccountService;
}());
export { PatientAccountService };
